module.exports = __webpack_public_path__ + "media/paid-services.6362a062.png";